import { render } from "./WorkflowExportRequirementsDialog.vue?vue&type=template&id=279c7c51"
import script from "./WorkflowExportRequirementsDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowExportRequirementsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__